export default __webpack_public_path__ + "static/media/Preschool-Rates.7f9bc016.png";